// 🧠 Avisamos a TypeScript que existirá 'withResolvers'
declare global {
  interface PromiseConstructor {
    withResolvers<T>(): {
      promise: Promise<T>;
      resolve: (value: T | PromiseLike<T>) => void;
      reject: (reason?: any) => void;
    };
  }
}

// 🛡️ Hacemos el polyfill real
if (typeof Promise.withResolvers !== 'function') {
  Promise.withResolvers = function <T = any>() {
    let resolve: (value: T | PromiseLike<T>) => void = () => {};
    let reject: (reason?: any) => void = () => {};
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

// 👇 Hacemos que el archivo sea un módulo válido para CRA
export {};
